import React, { useEffect, useRef, } from "react";
import { Tab, Tabs } from "react-bootstrap";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
var GenericTabs = function (props) {
    var device = DeviceContext();
    var tabsContainerRef = useRef(null);
    var onSelectAction = function (selected) {
        if (props.callBackFunction)
            props === null || props === void 0 ? void 0 : props.callBackFunction(selected);
    };
    useEffect(function () {
        var timeoutId = setTimeout(function () {
            if (props.activeKey && (props === null || props === void 0 ? void 0 : props.scrollTabs)) {
                var selectedTab = document.querySelector('[aria-selected="true"]');
                if (selectedTab) {
                    selectedTab.scrollIntoView({
                        behavior: "smooth",
                        block: "nearest",
                    });
                }
            }
        }, 300);
        return function () {
            clearTimeout(timeoutId);
        };
    }, [props.activeKey]);
    return (React.createElement("div", { className: "generic-tabs ".concat(props.externalClassName ? props.externalClassName : ""), ref: tabsContainerRef },
        React.createElement(Tabs, { defaultActiveKey: props.defaultActiveKey, onSelect: onSelectAction, className: props === null || props === void 0 ? void 0 : props.TabsClassName, activeKey: props.activeKey }, props.tabsArray &&
            props.tabsArray.map(function (tab, idx) {
                return (React.createElement(Tab, { title: React.createElement(React.Fragment, null,
                        tab.title,
                        tab.suffix ? props.suffixComp : ""), eventKey: tab.eventKey, disabled: tab.disabled, key: idx }, (props === null || props === void 0 ? void 0 : props.loadContentOnlyIfActive)
                    ? (tab.eventKey === props.activeKey ||
                        tab.eventKey === props.defaultActiveKey) &&
                        tab.tabContent
                    : tab.tabContent));
            }))));
};
export default GenericTabs;
